import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { Page } from '../models/project.model';
import { IProjectsStore } from './projects.store';

/**
 * This is the state of the Pages slice.
 */
export interface PagesState {
  allPages: Record<string, Page>;
}

/**
 * Actions related to the Pages state.
 */
export interface PagesActions {
  setPage: (page: Page) => void;
}

export type PagesSlice = {
  pages: PagesState & PagesActions;
};

/**
 * Creates the Pages slice. This function can be merged into
 * a larger store (e.g., a projects store).
 */
export const createPagesSlice: StateCreator<IProjectsStore, [], [], PagesSlice> = (set) => ({
  pages: {
    allPages: {},

    setPage: (page: Page) =>
      set(
        produce((draft: IProjectsStore) => {
          draft.pages.allPages[page.id] = page;
        })
      ),
  },
});
